import { Link } from "react-router-dom";

import { LearnGrid } from "@/components/LearnGrid";
import { PageHeader } from "@/components/PageHeader";
import { SEO } from "@/components/SEO";

export function TrainingPage() {
  return (
    <>
      <SEO
        title="Training"
        description="Learn real boxing at Membertou Boxing Club. Footwork, combinations, defense, conditioning, and more. Monday to Thursday, 6–8pm. No experience necessary."
        path="/training"
      />

      <PageHeader
        eyebrow={
          <>
            <span
              lang="mic"
              aria-label="Ta'n Wen'ju'te'kewinu'k Etl-kina'masulti'tij — Mi'kmaw for Where Warriors Train"
              className="block text-xs sm:text-sm not-italic normal-case font-medium tracking-widest uppercase"
              style={{ color: "#d71920", letterSpacing: "0.15em" }}
            >
              Ta&apos;n Wen&apos;ju&apos;te&apos;kewinu&apos;k Etl-kina&apos;masulti&apos;tij
            </span>
            <span className="block mt-1.5 text-[0.65rem] uppercase tracking-[0.2em]" style={{ color: "rgba(255,255,255,0.45)" }}>
              &mdash; Where Warriors Train
            </span>
          </>
        }
        title="Training"
        intro="Real boxing workouts, real coaching, real teammates."
      />

      <section className="section section-white texture-light" aria-labelledby="approach-heading">
        <div className="container-page max-w-3xl">
          <h2 id="approach-heading" className="sr-only">
            Our approach
          </h2>
          <p>
            Training at the Membertou Boxing Club is like training at any
            boxing school you will find anywhere in the world. The workouts are
            rigorous and demanding, and you are going to be worked as if you
            are training for your next boxing match. You will sweat, you will
            get tired, and you will do the same exercises that the world&apos;s
            greatest professionals have done throughout their careers. What you
            will learn are genuine boxing techniques through actual boxing
            workouts and methods.
          </p>
          <p className="mt-4">
            Coaches Greg and Daniel see the potential in each and every student
            who enters the gym and will do their best to bring out the champion
            in you. All students and fighters are offered equal encouragement
            and recognition, and you will also have the support of your
            teammates.
          </p>
          <p className="mt-4">
            The doors are always open to new and returning members. You are
            here to learn and to be an active participant. You will never be
            turned away, and you will be expected to work just as hard as
            your teammates standing next to you. The workouts will help you
            build character, strength, and confidence.
          </p>
          <p className="mt-6 text-lg font-semibold" style={{ color: "#d71920" }}>
            We encourage interested boxers to drop by for a workout &mdash; no
            experience necessary.
          </p>
        </div>
      </section>

      <section className="section texture-dark" aria-labelledby="learn-heading" style={{ backgroundColor: "#151515", color: "#fff" }}>
        <div className="container-page">
          <span className="eyebrow">Skills</span>
          <h2 id="learn-heading" className="mt-2">
            What You&apos;ll Learn
          </h2>
          <p className="mt-4 text-white/75 max-w-prose">
            Real boxing technique alongside world-class conditioning.
          </p>

          <div className="mt-10">
            <LearnGrid />
          </div>
        </div>
      </section>

      <section
        className="relative overflow-hidden"
        style={{ backgroundColor: "#d71920", color: "#fff" }}
        aria-labelledby="cta-heading"
      >
        <div className="container-page relative z-10 py-16 sm:py-20 text-center flex flex-col items-center gap-5">
          <h2 id="cta-heading" className="max-w-[20ch]">Ready to lace up?</h2>
          <p className="text-lg max-w-prose" style={{ color: "rgba(255,255,255,0.9)" }}>
            Start your boxing journey in Membertou.
          </p>
          <div className="mt-2 flex flex-col sm:flex-row w-full sm:w-auto justify-center gap-3 sm:gap-4">
            <Link to="/join" className="btn-on-red w-full sm:w-auto">
              Join Our Club
            </Link>
            <Link to="/contact" className="btn-on-red-outline w-full sm:w-auto">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
